
import { Component, Vue } from 'vue-property-decorator'

/**
 * ルートアクセス時のリダイレクト処理
 */
@Component
export default class RootView extends Vue {
  /**
   * 開始時の処理(自動遷移を行うため全てここで処理する)
   */
  private async created(): Promise<void> {
    this.$loading.start()

    // 先生ログイン情報の判定
    try {
      // ログイン情報を取得(存在しない場合は例外が発生する)
      this.$appCookies.authTeacher.get()
      this.$loading.complete()
      await this.$router.push('/teacher')
      return
    } catch {
      // 例外発生=ログイン情報がない
    }

    // 塾管理者ログイン情報の判定
    try {
      // ログイン情報を取得(存在しない場合は例外が発生する)
      this.$appCookies.authAcademy.get()
      this.$loading.complete()
      await this.$router.push('/academy')
      return
    } catch {
      // 例外発生=ログイン情報がない
    }

    // システム管理者ログイン情報の判定
    try {
      // ログイン情報を取得(存在しない場合は例外が発生する)
      this.$appCookies.authAdmin.get()
      this.$loading.complete()
      await this.$router.push('/admin')
      return
    } catch {
      // 例外発生=ログイン情報がない
    }

    // 全て該当しない場合は生徒用画面に遷移
    this.$loading.complete()
    await this.$router.push('/student')
  }
}
